import * as swcHelpers from '@swc/helpers';
import { initialize } from '@bloomreach/spa-sdk';
import { createConfiguration } from '../configuration/configuration.js';

/**
 *
 * @param apiUrl base Url for the API
 * @param path Url path
 * @param options client options, e.g.: locality, multilingualism, headers, visitor Id
 * @returns the page from Bloomreach API
 */ function getBrPage(apiUrl, path, options) {
    return _getBrPage.apply(this, arguments);
}
function _getBrPage() {
    _getBrPage = swcHelpers.asyncToGenerator(function*(apiUrl, path, options) {
        return initialize(createConfiguration({
            apiUrl,
            path,
            options
        }));
    });
    return _getBrPage.apply(this, arguments);
}

export { getBrPage };
//# sourceMappingURL=get-page.js.map
